import { call, put, takeLatest } from "redux-saga/effects";
import actionCreators from "../../actions/top/services";
import "babel-polyfill";

function* fetchServices() {
  try {
    const data = yield call(function() {
      const method = "GET";
      const credentials = "include";
      const mode = "no-cors";
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      return fetch("/api/top/services", { method, credentials, mode, headers })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(actionCreators.top.services.success({ services: data.services }));
  } catch (e) {
    yield put(actionCreators.top.services.failure(e));
  }
}

export default function*() {
  yield takeLatest(actionCreators.top.services.set, fetchServices);
}
